// This is the magical incantation to get amcharts exporting & annotations working.
// Requires fabric & file-server from NPM.

export default {
  enabled: true,
  libs: { autoLoad: false }, // bombs without this, use NPM instead
  drawing: {
    autoClose: false,
    menu: [
      {
        class: 'export-drawing',
        menu: [
          {
            label: 'Modes',
            action: 'draw.modes',
          },
          {
            label: 'Size',
            action: 'draw.widths',
            widths: [3, 8, 15],
          },
          {
            label: 'Colors',
            action: 'draw.colors',
          },
          {
            label: 'Opacity',
            action: 'draw.opacities',
          },
          {
            label: 'Download as Annotated Image',
            menu: ['PNG', 'JPG', 'SVG'],
          },
          {
            format: 'PRINT',
            label: 'Print Annotated Chart',
          },
          {
            label: 'Undo / Redo',
            menu: ['UNDO', 'REDO'],
          },
          {
            format: 'CANCEL',
            label: 'Exit Annotation Mode',
          },
        ],
      },
    ],
    color: '#FF0000',
    colors: ['#FF0000', '#00FF00', '#0000FF'],
    mode: 'arrow',
    modes: ['arrow', 'line', 'pencil'],
    width: 3,
  },
  menu: [
    {
      class: 'export-main',
      menu: [
        {
          label: 'Download as Image',
          menu: ['PNG', 'JPG', 'SVG'],
        },
        {
          label: 'Annotation Mode',
          action: 'draw',
        },
        {
          format: 'PRINT',
          label: 'Print Chart',
        },
      ],
    },
  ],
};
